import api from './apiClient'

export default {
  /**
   * 📋 Get users list (with filters & pagination)
   */
  async getFacilities(params = {}) {
    const res = await api.get('facilities', {
      params
    })
    return res.data
  },

  /**
   * ➕ Create facility
   */
  async createFacility(data) {
    try {
      const res = await api.post('facilities', data)

      return {
        data: res.data.data || res.data,   // handle different API shapes
        message: res.data.message || 'Facility created successfully'
      }

    } catch (error) {
      const err = error.response

      throw {
        status: err?.status,
        message: err?.data?.message || 'Something went wrong',
        errors: err?.data?.errors || {}
      }
    }
  },


  /**
   * 👤 Get single facility
   */
  async getFacility(id) {
    const res = await api.get(`facilities/${id}`)
    return res.data.data
  },

  

  /**
   * ✏️ Update facility
   */
  async updateFacility(id, data) {
    try {
      const res = await api.put(`facilities/${id}`, data)

      return {
        data: res.data.data || res.data,   // handle different API shapes
        message: res.data.message || 'Facility updated successfully'
      }

    } catch (error) {
      const err = error.response

      throw {
        status: err?.status,
        message: err?.data?.message || 'Something went wrong',
        errors: err?.data?.errors || {}
      }
    }
  },

  /**
   * ❌ Delete facility
   */
  async deleteFacility(id) {
    const res = await api.delete(`/facilities/${id}`)
    return res
  },

  async exportFacilities() {
    try {
      const res = await api.post(`/facilities/export`)
      return res.data
    } catch (error) {
      const err = error.response
      throw {
        status: err?.status,
        message: err?.data?.message || 'Something went wrong',
        errors: err?.errors || {}
      }
    }
  },
}